import Alert from 'react-s-alert';

const defaultState = {
  id: null,
  username: '',
  token: '',
  email: '',
  admin: true,
  isLogged: false,
  error: '',
  allUsers: [],
  isLoading: false,
  company: null,
};

export default function Users(state = defaultState, action) {
  switch (action.type) {
    case 'LOGIN_SUCCESS':
      localStorage.setItem('token', action.payload.auth_token);
      return {
        ...state,
        id: action.payload.id,
        email: action.payload.email,
        username: action.payload.username,
        admin: action.payload.admin,
        isLogged: true,
        isLoading: false,
        error: '',
        company: action.payload.company_id,
      };
    case 'LOGOUT_SUCCESS':
      return defaultState;
    case 'LOGIN_FAIL':
      localStorage.removeItem('token');
      return {
        ...state,
        error: action.payload,
      };
    case 'RESET_ERROR':
      return {
        ...state,
        error: '',
      };
    case 'GET_ALL_USERS_SUCCESS':
      return {
        ...state,
        allUsers: action.payload,
        isLoading: false,
        error: '',
      };
    case 'GET_ALL_USERS_PENDING':
      return {
        ...state,
        isLoading: true,
        error: '',
      };
    case 'CREATE_USER_SUCCESS':
      Alert.success('User created successfully', {timeout: 2000});
      return {
        ...state,
        allUsers: state.allUsers.concat(action.payload),
      };
    case 'UPDATE_USER_SUCCESS':
      Alert.success('User updated successfully', {timeout: 2000});
      return {
        ...state,
        allUsers: state.allUsers.map((item) => {
          if (item.id === action.payload.id) {
            return action.payload;
          }
          return item;
        }),
      };
    case 'DELETE_USER_SUCCESS':
      Alert.success('User deleted successfully', {timeout: 2000});
      return {
        ...state,
        allUsers: state.allUsers.filter((item) => item.id !== action.payload),
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/users.js